import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=45c0cc18&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=ts"
export * from "./ProductSelector.vue?vue&type=script&lang=ts"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=45c0cc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0cc18",
  null
  
)

export default component.exports